<template>
    <div class="min-h-screen overflow-hidden text-white bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900">
        <!-- Header -->
        <header
            class="px-4 py-2 border-b md:px-8 lg:px-12 xl:px-16 2xl:px-20 md:py-4 lg:py-6 bg-white/10 backdrop-blur-sm border-white/20">
            <div class="flex items-center justify-between">
                <div class="flex items-center space-x-2 md:space-x-4 lg:space-x-6">
                    <div
                        class="flex items-center justify-center w-8 h-8 rounded-lg md:w-12 md:h-12 lg:w-16 lg:h-16 xl:w-20 xl:h-20 bg-gradient-to-r from-yellow-400 to-rose-900">
                        <ApplicationLogo class="w-6 h-6 md:w-10 md:h-10 lg:w-12 lg:h-12 xl:w-16 xl:h-16 text-dark" />
                    </div>
                    <div>
                        <h1 class="text-lg font-bold md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl">FEB INFORMASI
                        </h1>
                        <p class="text-xs text-blue-200 md:text-sm lg:text-base xl:text-lg">Sistem Informasi Digital
                            Fakultas</p>
                    </div>
                </div>

                <div class="text-right">
                    <div class="font-mono text-xl font-bold md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl">{{
                        currentTime }}</div>
                    <div class="text-xs text-blue-200 md:text-sm lg:text-base xl:text-lg 2xl:text-xl">{{ currentDate }}
                    </div>
                    <div class="flex items-center justify-end mt-1 text-xs md:mt-2 md:text-sm lg:text-base"
                        :class="refreshCountdown <= 30 ? 'refresh-warning' : 'text-blue-300'">
                        <i class="mr-1 fas fa-sync-alt" :class="{ 'animate-spin': refreshCountdown <= 10 }"></i>
                        Auto-refresh: {{ formatCountdown }}
                    </div>
                </div>
            </div>
        </header>

        <!-- Main Content -->
        <div class="flex flex-col lg:flex-row min-h-[calc(100vh-120px)] lg:h-[calc(100vh-120px)] max-w-[100vw] mx-auto">
            <!-- Left Side - Kehadiran Info -->
            <div class="w-full p-4 lg:w-1/2 md:p-6 lg:p-8 xl:p-10 2xl:p-12">
                <div
                    class="h-full p-4 border md:p-6 lg:p-8 xl:p-10 bg-white/10 backdrop-blur-sm rounded-2xl border-white/20">
                    <div class="flex items-center mb-4 md:mb-6 lg:mb-8">
                        <div
                            class="flex items-center justify-center w-6 h-6 mr-2 bg-green-500 rounded-full md:w-8 md:h-8 lg:w-10 lg:h-10 xl:w-12 xl:h-12 md:mr-3 lg:mr-4">
                            <i class="text-xs text-white md:text-sm lg:text-base xl:text-lg fas fa-user-check"></i>
                        </div>
                        <h2 class="text-lg font-semibold md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl">Kehadiran
                            Hari Ini</h2>
                    </div>



                    <!-- Kehadiran List -->
                    <div class="relative p-3 overflow-hidden md:p-4 lg:p-6 bg-white/5 rounded-xl">
                        <!-- Carousel Container -->
                        <div class="relative">
                            <!-- Header dengan jumlah total kehadiran -->
                            <div class="flex items-center justify-between mb-3 md:mb-4 lg:mb-6 kehadiran-header">
                                <div class="text-xs text-blue-200 md:text-sm lg:text-base xl:text-lg">
                                    Total: {{ sortedKehadiran.length }} orang
                                </div>
                                <div class="text-xs text-gray-400 md:text-sm lg:text-base">
                                    {{ currentDate }}
                                </div>
                            </div>

                            <div
                                class="overflow-hidden max-h-72 md:max-h-96 lg:max-h-[500px] xl:max-h-[600px] 2xl:max-h-[700px]">
                                <div v-if="!sortedKehadiran || sortedKehadiran.length === 0"
                                    class="py-6 text-center text-gray-400 md:py-8 lg:py-12">
                                    <i
                                        class="mb-2 text-2xl md:mb-4 md:text-4xl lg:text-5xl xl:text-6xl fas fa-users-slash"></i>
                                    <p class="text-sm md:text-base lg:text-lg xl:text-xl">Tidak ada data kehadiran</p>
                                </div>
                                <div v-else class="relative kehadiran-container">
                                    <!-- Carousel Progress Indicator -->
                                    <div v-if="kehadiranTotalPages > 1"
                                        class="flex items-center justify-between mb-3 md:mb-4 lg:mb-6">
                                        <div class="text-xs text-blue-200 md:text-sm lg:text-base">
                                            {{ currentKehadiranIndex + 1 }} dari {{ kehadiranTotalPages }} halaman
                                        </div>
                                        <div class="flex space-x-1 md:space-x-2">
                                            <div v-for="page in kehadiranTotalPages" :key="page"
                                                class="w-1.5 h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 transition-all duration-500 rounded-full"
                                                :class="page - 1 === currentKehadiranIndex ? 'bg-cyan-400 w-4 md:w-6 lg:w-8 shadow-lg shadow-cyan-400/50' : 'bg-white/30'">
                                            </div>
                                        </div>
                                        <div class="text-xs text-gray-400 md:text-sm lg:text-base">
                                            Auto {{ 6 }}s
                                        </div>
                                    </div>

                                    <div
                                        class="space-y-2 md:space-y-3 lg:space-y-4 min-h-[300px] md:min-h-[384px] lg:min-h-[450px] xl:min-h-[500px] relative">
                                        <transition-group name="kehadiran-slide-up" tag="div"
                                            class="space-y-2 md:space-y-3 lg:space-y-4">
                                            <div v-for="(kehadiran, index) in currentKehadiranPage"
                                                :key="kehadiran?.id || `kehadiran-${currentKehadiranIndex}-${index}`"
                                                class="flex items-center justify-between px-2 py-2 transition-all duration-300 border-b rounded-lg md:px-3 lg:px-4 md:py-3 lg:py-4 border-white/10 last:border-b-0 hover:bg-white/5 kehadiran-item"
                                                :style="{
                                                    animationDelay: (index * 80 + 200) + 'ms'
                                                }">
                                                <div class="flex items-center space-x-2 md:space-x-3 lg:space-x-4">
                                                    <div
                                                        class="relative flex items-center justify-center w-8 h-8 transition-transform duration-200 transform rounded-full shadow-lg md:w-12 md:h-12 lg:w-14 lg:h-14 xl:w-16 xl:h-16 bg-gradient-to-r from-cyan-400 to-blue-500 hover:scale-105">
                                                        <img v-if="kehadiran.foto && !imageErrors[kehadiran.id]"
                                                            :src="getPhotoUrl(kehadiran.foto)"
                                                            :alt="kehadiran.nama_pimpinan || 'N/A'"
                                                            class="object-cover w-full h-full rounded-full"
                                                            @error="handleImageError(kehadiran.id)"
                                                            @load="handleImageLoad(kehadiran.id)">
                                                        <span v-else
                                                            class="text-xs font-semibold md:text-sm lg:text-base xl:text-lg">
                                                            {{ (kehadiran.nama_pimpinan || 'N/A').charAt(0) }}
                                                        </span>
                                                        <!-- Status indicator with pulse animation -->
                                                        <div class="absolute w-2 h-2 md:w-4 md:h-4 lg:w-5 lg:h-5 border-1 md:border-2 border-white rounded-full -bottom-0.5 md:-bottom-1 -right-0.5 md:-right-1 pulse-status"
                                                            :class="getStatusIndicatorClass(kehadiran?.status)"></div>
                                                    </div>
                                                    <div class="flex-1">
                                                        <div
                                                            class="text-sm font-medium text-white md:text-base lg:text-lg xl:text-xl">
                                                            {{ kehadiran.nama_pimpinan || 'N/A' }}</div>
                                                        <div class="text-xs text-gray-300 md:text-sm lg:text-base">{{
                                                            kehadiran.jabatan || 'N/A' }}</div>
                                                    </div>
                                                </div>
                                                <div class="text-right">
                                                    <div class="px-2 md:px-3 lg:px-4 py-1 md:py-1.5 lg:py-2 text-xs md:text-sm lg:text-base xl:text-lg font-semibold rounded-full"
                                                        :class="getStatusBadgeClass(kehadiran?.status)">
                                                        {{ getStatusLabel(kehadiran?.status) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </transition-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Side - Agenda -->
            <div class="w-full p-4 lg:w-1/2 md:p-6 lg:p-8 xl:p-10 2xl:p-12">
                <div class="h-full">
                    <!-- Agenda Section -->
                    <div v-if="agenda_mendatang && agenda_mendatang.length > 0"
                        class="h-full p-4 border md:p-6 lg:p-8 xl:p-10 bg-white/10 backdrop-blur-sm rounded-2xl border-white/20">
                        <div class="flex items-center mb-4 md:mb-6 lg:mb-8">
                            <div
                                class="flex items-center justify-center w-6 h-6 mr-2 bg-purple-500 rounded-full md:w-8 md:h-8 lg:w-10 lg:h-10 xl:w-12 xl:h-12 md:mr-3 lg:mr-4">
                                <i
                                    class="text-xs text-white md:text-sm lg:text-base xl:text-lg fas fa-calendar-alt"></i>
                            </div>
                            <h2 class="text-lg font-semibold md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl">Agenda
                                Mendatang</h2>
                        </div>

                        <div
                            class="space-y-3 md:space-y-4 lg:space-y-6 overflow-y-auto max-h-72 md:max-h-96 lg:max-h-[500px] xl:max-h-[600px] 2xl:max-h-[700px]">
                            <transition-group name="agenda-slide" tag="div" class="space-y-3 md:space-y-4 lg:space-y-6">
                                <div v-for="agenda in currentAgendaPage" :key="agenda.id"
                                    class="p-3 transition-all duration-300 border-l-2 border-purple-500 md:p-4 lg:p-6 xl:p-8 md:border-l-4 lg:border-l-6 bg-white/5 rounded-xl hover:bg-white/10">
                                    <h3
                                        class="text-base font-semibold text-purple-200 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl">
                                        {{ agenda.judul }}</h3>
                                    <div
                                        class="flex items-center mt-1 text-xs text-gray-300 md:mt-2 lg:mt-3 md:text-sm lg:text-base xl:text-lg">
                                        <i class="mr-2 fas fa-map-marker-alt"></i>
                                        <span>{{ agenda.tempat }}</span>
                                    </div>
                                    <div
                                        class="flex items-center mt-1 md:mt-1.5 lg:mt-2 text-xs md:text-sm lg:text-base xl:text-lg text-gray-400">
                                        <i class="mr-1 md:mr-2 lg:mr-3 fas fa-clock"></i>
                                        <span>{{ formatDate(agenda.tanggal) }} • {{ agenda.waktu_mulai }}</span>
                                    </div>
                                </div>
                            </transition-group>
                        </div>
                    </div>

                    <!-- Empty state untuk agenda -->
                    <div v-else
                        class="flex items-center justify-center h-full p-4 border md:p-6 lg:p-8 xl:p-10 bg-white/10 backdrop-blur-sm rounded-2xl border-white/20">
                        <div class="text-center text-gray-400">
                            <i
                                class="mb-2 text-3xl md:mb-4 lg:mb-6 md:text-6xl lg:text-7xl xl:text-8xl fas fa-calendar-times"></i>
                            <h3 class="mb-1 text-lg font-semibold md:mb-2 lg:mb-3 md:text-xl lg:text-2xl xl:text-3xl">
                                Tidak Ada Agenda</h3>
                            <p class="text-sm md:text-base lg:text-lg xl:text-xl">Belum ada agenda yang dijadwalkan</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom Ticker - Pengumuman -->
        <div
            class="fixed bottom-0 left-0 right-0 py-2 overflow-hidden md:py-3 lg:py-4 bg-gradient-to-r from-cyan-600 to-blue-600">
            <div
                class="px-2 text-sm font-medium md:px-4 lg:px-6 md:text-lg lg:text-xl xl:text-2xl scroll-text whitespace-nowrap">
                <span v-if="runningTextContent">{{ runningTextContent }}</span>
                <span v-else>📢 Selamat datang di Sistem Informasi Digital Fakultas Ekonomi dan Bisnis</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed, ref, onMounted, onUnmounted, watch } from "vue";
import { router } from '@inertiajs/vue3';
import ApplicationLogo from "@/Components/ApplicationLogo.vue";

const props = defineProps({
    // FEB Info specific props (same as Home.vue)
    kehadiran_hari_ini: {
        type: Array,
        default: () => [],
    },
    agenda_hari_ini: {
        type: Array,
        default: () => [],
    },
    agenda_mendatang: {
        type: Array,
        default: () => [],
    },
    pengumuman_aktif: {
        type: Array,
        default: () => [],
    },
    pengumuman_urgent: {
        type: Array,
        default: () => [],
    },
    undangan_hari_ini: {
        type: Array,
        default: () => [],
    },
    undangan_mendatang: {
        type: Array,
        default: () => [],
    },
    stats: {
        type: Object,
        default: () => ({}),
    },
});

// State variables
const currentTimeRef = ref(new Date());
const currentAgendaIndex = ref(0);
const currentKehadiranIndex = ref(0);
const imageErrors = ref({});
const imageLoaded = ref({});
const refreshCountdown = ref(300); // 5 minutes in seconds

// Intervals
let timeInterval = null;
let agendaInterval = null;
let kehadiranInterval = null;
let autoRefreshInterval = null;
let countdownInterval = null;

// Clock computeds
const currentTime = computed(() => {
    return currentTimeRef.value.toLocaleTimeString("id-ID", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    });
});

const currentDate = computed(() => {
    return currentTimeRef.value.toLocaleDateString("id-ID", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });
});

// Data processing computeds (same as Home.vue)
const sortedKehadiran = computed(() => {
    const data = props.kehadiran_hari_ini || [];
    const validData = data.filter(item => item && typeof item === 'object' && item.nama_pimpinan);
    return [...validData].sort((a, b) => {
        const nameA = a.nama_pimpinan?.toLowerCase() || '';
        const nameB = b.nama_pimpinan?.toLowerCase() || '';
        return nameA.localeCompare(nameB);
    });
});

const allPengumuman = computed(() => {
    const urgentPengumuman = (props.pengumuman_urgent || []).map((p) => ({
        ...p,
        is_urgent: true,
    }));
    const aktivePengumuman = (props.pengumuman_aktif || []).map((p) => ({
        ...p,
        is_urgent: false,
    }));
    return [...urgentPengumuman, ...aktivePengumuman];
});

// Running text content (same as Home.vue)
const runningTextContent = computed(() => {
    const urgentPengumuman = (props.pengumuman_urgent || []).map((p) => ({
        ...p,
        priority: "urgent",
    }));
    const aktivePengumuman = (props.pengumuman_aktif || []).map((p) => ({
        ...p,
        priority: "active",
    }));

    const allPengumumanData = [...urgentPengumuman, ...aktivePengumuman];

    if (allPengumumanData.length === 0) return null;

    const textItems = allPengumumanData.map((p) => {
        const icon = p.priority === "urgent" ? "🚨" : "📢";
        const date = p.tanggal_publikasi ? formatDate(p.tanggal_publikasi) : "";
        return `${icon} ${p.judul} - ${p.penerbit} ${date ? `(${date})` : ""}`;
    });

    return textItems.join(" • ") + " • " + textItems.join(" • ") + " • ";
});

// Statistics computed
const attendanceStats = computed(() => {
    const data = sortedKehadiran.value || [];
    const stats = {
        hadir: 0,
        tidak_hadir: 0,
        terlambat: 0,
        sakit: 0,
        izin: 0,
        total: data.length
    };

    data.forEach(item => {
        const status = item?.status || 'tidak_hadir';
        if (stats.hasOwnProperty(status)) {
            stats[status]++;
        }
    });

    return stats;
});

// Pagination computeds
const currentKehadiranPage = computed(() => {
    const itemsPerPage = 6;
    const startIndex = currentKehadiranIndex.value * itemsPerPage;
    return sortedKehadiran.value.slice(startIndex, startIndex + itemsPerPage);
});

const kehadiranTotalPages = computed(() => {
    const itemsPerPage = 6;
    return Math.ceil(sortedKehadiran.value.length / itemsPerPage);
});

const currentAgendaPage = computed(() => {
    const itemsPerPage = 5;
    const startIndex = currentAgendaIndex.value * itemsPerPage;
    return (props.agenda_mendatang || []).slice(startIndex, startIndex + itemsPerPage);
});

// Helper functions (same as Home.vue)
const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
};

const formatTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleTimeString("id-ID", {
        hour: "2-digit",
        minute: "2-digit",
    });
};

const getStatusLabel = (status) => {
    if (!status) return "N/A";
    const labels = {
        hadir: "Hadir",
        tidak_hadir: "Tidak Hadir",
        terlambat: "Terlambat",
        sakit: "Sakit",
        izin: "Izin",
    };
    return labels[status] || status;
};

const getStatusIndicatorClass = (status) => {
    const classes = {
        hadir: "bg-green-500",
        tidak_hadir: "bg-red-500",
        terlambat: "bg-yellow-500",
        sakit: "bg-blue-500",
        izin: "bg-purple-500",
    };
    return classes[status] || "bg-gray-500";
};

const getStatusTextClass = (status) => {
    const classes = {
        hadir: "text-green-400",
        tidak_hadir: "text-red-400",
        terlambat: "text-yellow-400",
        sakit: "text-blue-400",
        izin: "text-purple-400",
    };
    return classes[status] || "text-gray-400";
};

const getStatusBadgeClass = (status) => {
    const classes = {
        hadir: "bg-green-500/20 text-green-300 border border-green-500/30",
        tidak_hadir: "bg-red-500/20 text-red-300 border border-red-500/30",
        terlambat: "bg-yellow-500/20 text-yellow-300 border border-yellow-500/30",
        sakit: "bg-blue-500/20 text-blue-300 border border-blue-500/30",
        izin: "bg-purple-500/20 text-purple-300 border border-purple-500/30",
    };
    return classes[status] || "bg-gray-500/20 text-gray-300 border border-gray-500/30";
};

const getPhotoUrl = (foto) => {
    if (!foto) return '';
    if (foto.startsWith('http')) return foto;
    return `/storage/${foto}`;
};

const handleImageError = (id) => {
    imageErrors.value[id] = true;
};

const handleImageLoad = (id) => {
    imageLoaded.value[id] = true;
    imageErrors.value[id] = false;
};

// Clock update function
const updateTime = () => {
    currentTimeRef.value = new Date();
};

// Rotation functions
const rotateKehadiran = () => {
    if (kehadiranTotalPages.value > 1) {
        currentKehadiranIndex.value = (currentKehadiranIndex.value + 1) % kehadiranTotalPages.value;
    }
};

const rotateAgenda = () => {
    const itemsPerPage = 5;
    const totalPages = Math.ceil((props.agenda_mendatang || []).length / itemsPerPage);
    if (totalPages > 1) {
        currentAgendaIndex.value = (currentAgendaIndex.value + 1) % totalPages;
    }
};

// Watch for kehadiran data changes to restart carousel if needed
watch(() => sortedKehadiran.value.length, (newLength) => {
    // Clear existing interval
    if (kehadiranInterval) {
        clearInterval(kehadiranInterval);
        kehadiranInterval = null;
    }

    // Reset to first page
    currentKehadiranIndex.value = 0;

    // Start carousel only if more than 6 items
    if (newLength > 6) {
        kehadiranInterval = setInterval(rotateKehadiran, 6000);
    }
});

// Auto-refresh function
const autoRefreshPage = () => {
    router.reload({
        only: ['kehadiran_hari_ini', 'agenda_hari_ini', 'agenda_mendatang', 'pengumuman_aktif', 'pengumuman_urgent', 'undangan_hari_ini', 'undangan_mendatang', 'stats'],
        preserveScroll: true,
        preserveState: true
    });
    // Reset countdown after refresh
    refreshCountdown.value = 300;
};

// Countdown function
const updateCountdown = () => {
    if (refreshCountdown.value > 0) {
        refreshCountdown.value--;
    } else {
        autoRefreshPage();
    }
};

// Format countdown for display
const formatCountdown = computed(() => {
    const minutes = Math.floor(refreshCountdown.value / 60);
    const seconds = refreshCountdown.value % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
});

onMounted(() => {
    // Start all intervals
    updateTime();
    timeInterval = setInterval(updateTime, 1000);
    agendaInterval = setInterval(rotateAgenda, 8000);
    // Only start kehadiran carousel if there are more than 6 items
    if (sortedKehadiran.value.length > 6) {
        kehadiranInterval = setInterval(rotateKehadiran, 6000);
    }

    // Start countdown timer (updates every second)
    countdownInterval = setInterval(updateCountdown, 1000);
});

onUnmounted(() => {
    // Clean up intervals
    if (timeInterval) clearInterval(timeInterval);
    if (agendaInterval) clearInterval(agendaInterval);
    if (kehadiranInterval) clearInterval(kehadiranInterval);
    if (countdownInterval) clearInterval(countdownInterval);
});
</script>

<style scoped>
.scroll-text {
    animation: scroll 30s linear infinite;
}

@keyframes scroll {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(-100%);
    }
}

/* Enhanced Carousel Animations */
.carousel-slide-enter-active {
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.carousel-slide-leave-active {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.carousel-slide-enter-from {
    transform: translateX(40px) scale(0.95);
    opacity: 0;
}

.carousel-slide-leave-to {
    transform: translateX(-40px) scale(0.95);
    opacity: 0;
}

.carousel-slide-move {
    transition: transform 0.5s ease-in-out;
}

/* Progress Bar Animation */
.carousel-progress {
    animation: progressFill 8s linear infinite;
}

@keyframes progressFill {
    0% {
        width: 0%;
    }

    100% {
        width: 100%;
    }
}

/* Status Pulse Animation */
.pulse-status {
    animation: statusPulse 2s ease-in-out infinite;
}

@keyframes statusPulse {

    0%,
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.7);
    }

    50% {
        transform: scale(1.1);
        box-shadow: 0 0 0 4px rgba(99, 102, 241, 0);
    }
}

/* Kehadiran Item Animation - Slide Up from Bottom */
.kehadiran-item {
    animation: slideUpFromBottom 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
    opacity: 0;
    transform: translateY(40px) scale(0.95);
    will-change: transform, opacity;
}

@keyframes slideUpFromBottom {
    0% {
        opacity: 0;
        transform: translateY(40px) scale(0.95);
        filter: blur(2px);
    }

    30% {
        opacity: 0.6;
        transform: translateY(20px) scale(0.98);
        filter: blur(1px);
    }

    60% {
        opacity: 0.9;
        transform: translateY(-2px) scale(1.01);
        filter: blur(0px);
        box-shadow: 0 8px 20px rgba(56, 189, 248, 0.2);
    }

    80% {
        transform: translateY(1px) scale(1.005);
        box-shadow: 0 6px 15px rgba(56, 189, 248, 0.15);
    }

    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
        filter: blur(0px);
        box-shadow: 0 4px 12px rgba(56, 189, 248, 0.1);
    }
}

/* Header animation */
.kehadiran-header {
    animation: headerSlideIn 0.6s ease-out forwards;
    opacity: 0;
    transform: translateY(-20px);
}

@keyframes headerSlideIn {
    0% {
        opacity: 0;
        transform: translateY(-20px) scale(0.95);
    }

    60% {
        opacity: 0.8;
        transform: translateY(-5px) scale(1.02);
    }

    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Container animation */
.kehadiran-container {
    animation: containerFadeIn 0.8s ease-out 0.2s forwards;
    opacity: 0;
}

@keyframes containerFadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Kehadiran Carousel Slide Up Animation */
.kehadiran-slide-up-enter-active {
    transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.kehadiran-slide-up-leave-active {
    transition: all 0.6s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.kehadiran-slide-up-enter-from {
    opacity: 0;
    transform: translateY(60px) scale(0.9);
    filter: blur(4px);
}

.kehadiran-slide-up-leave-to {
    opacity: 0;
    transform: translateY(-60px) scale(0.9);
    filter: blur(4px);
}

.kehadiran-slide-up-move {
    transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Agenda Transition Group */
.agenda-slide-enter-active {
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.agenda-slide-leave-active {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.agenda-slide-enter-from {
    opacity: 0;
    transform: translateX(30px) scale(0.95);
}

.agenda-slide-leave-to {
    opacity: 0;
    transform: translateX(-30px) scale(0.95);
}

.agenda-slide-move {
    transition: transform 0.5s ease-in-out;
}

/* Hover effect enhancement untuk kehadiran item */
.kehadiran-item:hover {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(59, 130, 246, 0.3);
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Legacy slide animations for other sections */
.slide-enter-active,
.slide-leave-active {
    transition: all 0.5s ease-in-out;
}

.slide-enter-from {
    transform: translateX(30px);
    opacity: 0;
}

.slide-leave-to {
    transform: translateX(-30px);
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.line-clamp-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* Hover Effects */
.hover\:bg-white\/5:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

/* Custom Transition Durations */
.duration-8000 {
    transition-duration: 8000ms;
}

/* Carousel indicator pulse animation */
@keyframes indicatorPulse {

    0%,
    100% {
        box-shadow: 0 0 5px rgba(56, 189, 248, 0.5);
    }

    50% {
        box-shadow: 0 0 15px rgba(56, 189, 248, 0.8);
    }
}

.shadow-cyan-400\/50 {
    animation: indicatorPulse 2s ease-in-out infinite;
}

/* Auto-refresh warning animation */
@keyframes refreshWarning {

    0%,
    100% {
        color: rgb(147, 197, 253);
        /* blue-300 */
    }

    50% {
        color: rgb(251, 191, 36);
        /* amber-400 */
    }
}

.refresh-warning {
    animation: refreshWarning 1s ease-in-out infinite;
}

/* Responsive adjustments for large screens */
@media (min-width: 1920px) {
    .text-responsive-xl {
        font-size: 1.5rem;
    }

    .text-responsive-2xl {
        font-size: 2rem;
    }

    .text-responsive-3xl {
        font-size: 2.5rem;
    }
}

@media (min-width: 2560px) {
    .text-responsive-xl {
        font-size: 2rem;
    }

    .text-responsive-2xl {
        font-size: 2.75rem;
    }

    .text-responsive-3xl {
        font-size: 3.5rem;
    }
}

/* Ultra-wide and TV screen optimizations */
@media (min-width: 3840px) {
    .text-responsive-xl {
        font-size: 2.5rem;
    }

    .text-responsive-2xl {
        font-size: 3.5rem;
    }

    .text-responsive-3xl {
        font-size: 4.5rem;
    }
}
</style>